import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderCell,
  TableCell,
  TableRow,
} from "semantic-ui-react";
import React from "react";

const ChargeTaxBreakdown = ({ selectedCharge, formatter}) => {
  return (
    <div className="ui segment">
      <div className="ui dividing header">Charge Tax Breakdown</div>
      {!selectedCharge ? (
        <div style={{ marginTop: "5px", textAlign: "center" }}>
          Please select a Charge for charge tax breakdown
        </div>
      ) : (
        <>
          {selectedCharge.jobEvInvoicesTaxDetailList &&
          selectedCharge.jobEvInvoicesTaxDetailList.length > 0 ? (
            <Table celled>
              <TableHeader>
                <TableRow>
                  <TableHeaderCell>Tax</TableHeaderCell>
                  <TableHeaderCell>Percentage (%)</TableHeaderCell>
                  <TableHeaderCell>Tax Amount</TableHeaderCell>
                  <TableHeaderCell>Before Tax</TableHeaderCell>
                  <TableHeaderCell>After Tax</TableHeaderCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {selectedCharge.jobEvInvoicesTaxDetailList.map((td) => (
                  <TableRow>
                    <TableCell>{td?.taxName}</TableCell>
                    <TableCell>
                      {formatter
                        ? formatter.format(td?.eitTadValue)
                        : td?.eitTadValue}
                    </TableCell>
                    <TableCell>
                      {formatter
                        ? formatter.format(td?.eitValue)
                        : td?.eitValue}
                    </TableCell>
                    <TableCell>
                      {formatter
                        ? formatter.format(td?.beforeTax)
                        : td?.beforeTax}
                    </TableCell>
                    <TableCell>
                      {formatter
                        ? formatter.format(td?.afterTax)
                        : td?.afterTax}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <div style={{ marginTop: "5px", textAlign: "center" }}>
              No charge breakdown found
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ChargeTaxBreakdown;
